import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderObjectSelectionData } from 'gql/graphql';
import type {
    IUseGetIncludedCountDataProps,
    IUseGetIncludedCountDataResult,
} from 'pages/Project/Common/WorkOrderStructure/types';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderObjectSelectionListIsIncludedGql } from '../../workOrderQueries';

const requestId = 'uerWorkOrderObjectSelectionListIsIncluded';

export const useUerWorkOrderGetIncludedCountData = (
    props: IUseGetIncludedCountDataProps,
): IUseGetIncludedCountDataResult<WorkOrderObjectSelectionData> => {
    const dispatch = useDispatch();
    const { workOrderOrChangeId } = props;

    const [
        uerWorkOrderObjectSelectionListIsIncludedData,
        uerWorkOrderObjectSelectionListIsIncludedStatus,
        ,
        uerWorkOrderObjectSelectionListIsIncludedRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderObjectSelectionListIsIncludedGql,
        withEffect: false,
    });

    const [uerWorkOrderObjectSelectionListIsIncludedReset] = useResetStoreData({ requestId });

    const reset = useCallback(
        () => uerWorkOrderObjectSelectionListIsIncludedReset(undefined),
        [uerWorkOrderObjectSelectionListIsIncludedReset],
    );

    const makeRequest = useCallback(
        (constructionTypeId?: number) => {
            const where = constructionTypeId
                ? {
                      constructionType: { id: { eq: constructionTypeId } },
                  }
                : undefined;

            dispatch(uerWorkOrderObjectSelectionListIsIncludedRequest({ workOrderId: workOrderOrChangeId, where }));
        },
        [dispatch, uerWorkOrderObjectSelectionListIsIncludedRequest, workOrderOrChangeId],
    );

    const items = useMemo(
        () =>
            (uerWorkOrderObjectSelectionListIsIncludedData?.uerWorkOrderObjectSelectionList?.items ||
                []) as WorkOrderObjectSelectionData[],
        [uerWorkOrderObjectSelectionListIsIncludedData?.uerWorkOrderObjectSelectionList?.items],
    );

    return {
        constructionTypeIdGetMap: ['constructionType', 'id'],
        includedFlagGetMap: ['isIncluded'],
        items,
        makeRequest,
        reset,
        status: uerWorkOrderObjectSelectionListIsIncludedStatus,
    };
};
